import React, { Component } from 'react';
import PropTypes from 'prop-types';
import HomePageSlider from './HomePageSlider';
import RecentReportView from './RecentReportView';


export default class RecentReportsViewContainer extends Component {
  render() {
    const { recentReportViewList, preview } = this.props;
    return (
      <div className='recent-container-wrapper'>
        <div className="recent-container-title">
          <label> Reports </label>
        </div>
        <div className='recent-container'>
            <HomePageSlider recentReportViewList={recentReportViewList} preview={preview}/>
        </div>
      </div>
    );
  }
}

/**
 * @property propTypes
 * @description property types for component
 * @type {function} preview: callback that for when a user clicks on report
 * @type {[object]} recentReportViewList: list of report objects that have recently been viewed
 */
RecentReportsViewContainer.propTypes = {
  preview: PropTypes.func.isRequired,
  recentReportViewList: PropTypes.object.isRequired
};



// WEBPACK FOOTER //
// ./ui/modules/Explore/NLQAsk/RecentReportsViewContainer.js